import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import { BaseButton } from '../../../../../BaseComponents';
import { getIsAwaitingPaymentExchange, getIsOpenedLastExchange } from '../../../../../Checkout/store/order/selectors';
import { getIsLoadingByType } from '@entities/exchange';
import { ClearLastExchangeButton } from '@features/order/clear-last-exchange';
import { RefuseExchangeButton } from '@features/exchange/refuse-exchange';
import { useRouter } from '@shared/lib/router';
const ExchangeRequestControls = () => {
    const { t } = useTranslation('Exchange');
    const { ExchangeRequestControls: theme } = useTheme('Widgets').Exchange;
    const isAwaitingPaymentExchange = useSelector(getIsAwaitingPaymentExchange);
    const isOpenedLastExchange = useSelector(getIsOpenedLastExchange);
    const isRefuseLoading = useSelector(getIsLoadingByType('refuse-exchange'));
    const router = useRouter();
    const onGoToPayment = () => {
        router.navigate('/exchange/payment');
    };
    return (React.createElement("div", { className: theme.root },
        isOpenedLastExchange && React.createElement(RefuseExchangeButton, null),
        isAwaitingPaymentExchange && !isRefuseLoading && (React.createElement(BaseButton, { variant: "action", onClick: onGoToPayment }, t('ExchangeRequestControls.Payment'))),
        !isOpenedLastExchange && !isRefuseLoading && (React.createElement(ClearLastExchangeButton, { label: t('ExchangeRequestControls.NewRequest') }))));
};
export default ExchangeRequestControls;
